export const toRemoveMinusSignOnMonetaryValues = value =>
  value.replace(/(R\$)( )(-)?(\d+,\d+)/, "$1$2$4")

export default toRemoveMinusSignOnMonetaryValues
